import { Button, Divider } from "@material-ui/core";
import { FieldArray, Form, Formik } from "formik";
import React from "react";
import styled from "styled-components";
import WorkflowStep from "./WorkflowStep";
import WorkflowFormAuthApproveOption from "./WorkflowFormAutoApproveOption";
// Here is an example of a form with an editable list.
// Next to each input are buttons for insert and remove.
// If the list is empty, there is a button to add an item.

const AddButtonContainer = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  background-color: #ecf5fa;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const MessageContainer = styled.div`
  padding-top: 20px;
  // padding-bottom : 10px;
  padding-left: 20px;
  padding-right: 10px;
  width: 100%;
  max-width: 500px;
  color: red;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
`;

const ContainerFooter = styled.div`
  padding-top: 10px;
  width: 100%;
  display: flex;
  height: 40px;
  justify-content: flex-end;
  padding-right: 20px;
  border-top-width: 1px;
`;

const AddButtonHelperText = styled.div`
  font-weight: 500;
  font-size: 15px;
`;

const PaddingContainer = styled.div`
  padding: 10px;
`;

const ButtonContainer = styled.div`
  padding: 10px;
`;

function validateStepScope(formProps) {
  let hasError = false;
  formProps.values.workflowSteps.forEach((workflowStep, index) => {
    if (workflowStep.stepScope === "" || workflowStep.stepLabel === "")
      hasError = true;
    if (index === 0 && workflowStep.stepScope === "CORP") hasError = true;
    if (
      index > 0 &&
      workflowStep.stepScope === "PROJECT" &&
      (formProps.values.workflowSteps[index - 1].stepScope === "GBU" ||
        formProps.values.workflowSteps[index - 1].stepScope === "CORP")
    )
      hasError = true;
    if (
      index > 0 &&
      workflowStep.stepScope === "GBU" &&
      formProps.values.workflowSteps[index - 1].stepScope === "CORP"
    )
      hasError = true;
  });
  return hasError;
}

const WorkflowForm = (props) => (
  <div>
    <Formik
      initialValues={props.initialValues}
      validate
      onSubmit={(values) =>
        setTimeout(() => {
          alert(JSON.stringify(values, null, 2));
        }, 500)
      }
      render={(formProps) => (
        <Form>
          <FieldArray
            name="workflowSteps"
            render={(arrayHelpers) => (
              <>
                <AddButtonContainer>
                  <AddButtonHelperText>
                    Add, edit, or delete approval steps
                  </AddButtonHelperText>
                  <Button
                    onClick={() =>
                      arrayHelpers.push({ stepLabel: "", stepScope: "" })
                    }
                    color="primary"
                  >
                    + ADD WORKFLOW STEP
                  </Button>
                </AddButtonContainer>
                <Divider />
                <PaddingContainer />
                {formProps.values.workflowSteps && (
                  <>
                    {formProps.values.workflowSteps.map(
                      (workflowStep, index) => (
                        <WorkflowStep
                          formProps={formProps}
                          arrayHelpers={arrayHelpers}
                          index={index}
                        />
                      )
                    )}
                    <Divider />
                    <WorkflowFormAuthApproveOption />
                    <Divider />
                    <ContainerFooter>
                      {validateStepScope(formProps) && (
                        <MessageContainer>
                          {
                            "Fill all the values. And Approval steps must proceed from Project > GBU > Corporate."
                          }
                        </MessageContainer>
                      )}
                      <ButtonContainer>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            props.context.closeWorkflowDialog();
                          }}
                        >
                          Cancel
                        </Button>
                      </ButtonContainer>

                      <ButtonContainer>
                        <Button
                          variant="contained"
                          color="primary"
                          disabled={validateStepScope(formProps)}
                          onClick={() => {
                            props.context.updateWorkflow(formProps.values);
                            props.context.closeWorkflowDialog();
                          }}
                        >
                          Save
                        </Button>
                      </ButtonContainer>
                    </ContainerFooter>
                  </>
                )}
              </>
            )}
          />
        </Form>
      )}
    />
  </div>
);

export default WorkflowForm;
